import { getAdminUser, addAdminUser, updateAdminUser, deleteAdminUser, getActionList, getSystemUser,
  getUserActionList, setUserAction, getUserRegion, setUserRegion, getFileList, uploadManageFile,
  deleteFile, emptyFileManage, getTabList, addTabList, deleteTabList, getAdminUserLoginInfoList, getAdminUserLoginInfoByID, updateAdminUserStatus } from '@/api/adminuser'

const adminuser = {
  state: {
    total: 0,
    rows: [],
    tabs: [],
    row: {},
    files: []
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    },
    SET_FILES: (state, files) => {
      state.files = files
    },
    SET_TABS: (state, tabs) => {
      state.tabs = tabs
    }
  },
  actions: {
    // 获取管理用户信息
    GetAdminUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        getAdminUser(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetAdminUserLoginInfoList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getAdminUserLoginInfoList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetAdminUserLoginInfoByID({ commit }, params) {
      return new Promise((resolve, reject) => {
        getAdminUserLoginInfoByID(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加管理用户信息
    AddAdminUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        addAdminUser(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 更新管理用户信息
    UpdateAdminUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateAdminUser(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除管理用户信息
    DeleteAdminUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteAdminUser(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取Action
    GetActionList({ commit }) {
      return new Promise((resolve, reject) => {
        getActionList().then(response => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取后台用户
    GetSystemUser({ commit }) {
      return new Promise((resolve, reject) => {
        getSystemUser().then(response => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取UserAction
    GetUserActionList({ commit }, UserID) {
      return new Promise((resolve, reject) => {
        getUserActionList(UserID).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 设置UserAction
    SetUserAction({ commit }, params) {
      return new Promise((resolve, reject) => {
        setUserAction(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户region
    GetUserRegion({ commit }, userid) {
      return new Promise((resolve, reject) => {
        getUserRegion(userid).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 设置用户region
    SetUserRegion({ commit }, params) {
      return new Promise((resolve, reject) => {
        setUserRegion(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取文件列表
    GetFileList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getFileList(params).then(response => {
          commit('SET_FILES', response.Data.Files)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 上传文件
    UploadManageFile({ commit }, params) {
      return new Promise((resolve, reject) => {
        uploadManageFile(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除文件
    DeleteFile({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteFile(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 清空新文件状态
    EmptyFileManage({ commit }, params) {
      return new Promise((resolve, reject) => {
        emptyFileManage(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取Tab列表
    GetTabList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getTabList(params).then(response => {
          commit('SET_TABS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加Tab列表
    AddTabList({ commit }, params) {
      return new Promise((resolve, reject) => {
        addTabList(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除Tab列表
    DeleteTabList({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteTabList(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 更新管理用户状态信息
    UpdateAdminUserStatus({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateAdminUserStatus(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default adminuser



// WEBPACK FOOTER //
// ./src/store/modules/adminuser.js